import { UPGRADE_LIBRARY_VIEWED } from "constants/Events";
import { useTrackEvent } from "libs/analytics";
import { goToManagePlan } from "utils/manage-plan";

/**
 * Hook that used to open the UGC/library upsell modal. Since the reverse-trial
 * work the "upsell" is now a navigation to /onboarding/manage-plan. The hook
 * shape is preserved so existing call sites don't need to change.
 */
export function useUGCUpsellModal() {
  const trackEvent = useTrackEvent();
  return {
    showUGCUpsellModal: () => {
      trackEvent({
        eventName: UPGRADE_LIBRARY_VIEWED,
        useServices: ["AMP", "HS"],
      });
      goToManagePlan();
    },
  };
}
